export class AccountNoteAddCommand{
    caseId:string;
    text:string;

    constructor(caseId:string, text:string){
        this.caseId = caseId;
        this.text = text;
    }
}